



















import { defineComponent } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import Citations from '@/components/feature/PDP/Citations.vue'
import CitationsV3 from '@/components/feature/PDP/CitationsV3.vue'
import { useProductStore } from '~/store/product'
import { ATG_BE_CONF } from '~/common/utils/product/constants'
import { PDPTemplateComponent } from '~/modules/contentstack/pdpTemplateParser'
import { useFeatureFlag } from '~/composables/featureFlags/useFeatureFlag'

export default defineComponent({
  components: { Citations, CitationsV3 },
  props: {
    templateComponentData: {
      type: Object as () => PDPTemplateComponent,
      required: true,
    },
  },
  setup() {
    const { currentProduct } = storeToRefs(useProductStore())

    const productId = currentProduct.value.data.key
    const references = currentProduct.value.data.references
    const showNewCitations = useFeatureFlag('showNewCitations')

    return { ATG_BE_CONF, productId, references, showNewCitations }
  },
})
